(function () {
  var svgCache = {};

  var PLACEHOLDER_SCHOOL = 'SCHOOL';
  var PLACEHOLDER_NAME = 'YOUR NAME';
  var PLACEHOLDER_NUMBER = '00';

  // Digits-only, max 2 characters, no reformatting — preserves "0", "01",
  // "02" exactly as typed.
  function sanitizeNumberValue(value) {
    return value.replace(/\D/g, '').slice(0, 2);
  }

  function findActiveMedia() {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return null;
    var slide = gallery.querySelector('slideshow-slide[aria-hidden="false"]');
    if (!slide) return null;
    return slide.querySelector('.product-media');
  }

  function fetchSvgText(url) {
    if (svgCache[url]) return svgCache[url];
    svgCache[url] = fetch(url).then(function (response) {
      return response.text();
    });
    return svgCache[url];
  }

  function applyColorToSvg(svgEl, colorHex) {
    var shapes = svgEl.querySelectorAll('path, polygon, circle, rect, ellipse, line, polyline');
    if (shapes.length === 0) {
      svgEl.style.fill = colorHex;
      return;
    }
    shapes.forEach(function (shape) {
      shape.style.fill = colorHex;
    });
  }

  function getImageMetrics(img, positioningAncestor) {
    var imgRect = img.getBoundingClientRect();
    var ancestorRect = positioningAncestor.getBoundingClientRect();
    var naturalWidth = img.naturalWidth || imgRect.width;
    var naturalHeight = img.naturalHeight || imgRect.height;
    if (!naturalWidth || !naturalHeight || !imgRect.width || !imgRect.height) {
      return null;
    }
    var fit = window.getComputedStyle(img).objectFit || 'cover';
    var scale = fit === 'contain'
      ? Math.min(imgRect.width / naturalWidth, imgRect.height / naturalHeight)
      : Math.max(imgRect.width / naturalWidth, imgRect.height / naturalHeight);
    var renderedWidth = naturalWidth * scale;
    var renderedHeight = naturalHeight * scale;
    return {
      renderedWidth: renderedWidth,
      renderedHeight: renderedHeight,
      cropOffsetX: (renderedWidth - imgRect.width) / 2,
      cropOffsetY: (renderedHeight - imgRect.height) / 2,
      imgOffsetLeft: imgRect.left - ancestorRect.left,
      imgOffsetTop: imgRect.top - ancestorRect.top
    };
  }

  function initCustomizer(root) {
    var trigger = root.querySelector('[data-customizer-trigger]');
    var note = root.querySelector('[data-customizer-note]');
    var editButton = root.querySelector('[data-customizer-edit]');
    var dialog = root.querySelector('[data-customizer-dialog]');
    var closeButton = root.querySelector('[data-customizer-close]');
    var stage = root.querySelector('[data-customizer-stage]');
    var localImage = root.querySelector('[data-customizer-image]');
    var namePreview = root.querySelector('[data-customizer-name-preview]');
    var nameInput = root.querySelector('[data-customizer-name-input]');
    var schoolNamePreview = root.querySelector('[data-customizer-school-name-preview]');
    var schoolNameInput = root.querySelector('[data-customizer-school-name-input]');
    var digitsContainer = root.querySelector('[data-customizer-digits]');
    var numberInput = root.querySelector('[data-customizer-number-input]');
    var colorButtons = root.querySelectorAll('[data-customizer-color]');
    var colorHiddenInput = root.querySelector('[data-customizer-color-input]');
    var schoolColorButtons = root.querySelectorAll('[data-customizer-school-color]');
    var schoolColorHiddenInput = root.querySelector('[data-customizer-school-color-input]');
    var saveButton = root.querySelector('[data-customizer-save]');

    if (!trigger || !dialog || !stage || !nameInput || !schoolNameInput || !numberInput || !digitsContainer || !namePreview || !schoolNamePreview) return;

    var digitUrls = [];
    try {
      digitUrls = JSON.parse(root.getAttribute('data-digit-urls') || '[]');
    } catch (e) {
      digitUrls = [];
    }

    var nameFontPct = parseFloat(root.getAttribute('data-name-font-pct') || '6');
    var schoolNameFontPct = parseFloat(root.getAttribute('data-school-name-font-pct') || '3');
    var digitSizePct = parseFloat(root.getAttribute('data-digit-size-pct') || '8');
    var digitGapPct = parseFloat(root.getAttribute('data-digit-gap-pct') || '1');
    var nameMaxLength = parseInt(root.getAttribute('data-name-max-length') || '12', 10);
    var schoolNameMaxLength = parseInt(root.getAttribute('data-school-name-max-length') || '20', 10);
    var namePosX = parseFloat(root.getAttribute('data-name-pos-x') || '50');
    var namePosY = parseFloat(root.getAttribute('data-name-pos-y') || '30');
    var schoolNamePosX = parseFloat(root.getAttribute('data-school-name-pos-x') || '50');
    var schoolNamePosY = parseFloat(root.getAttribute('data-school-name-pos-y') || '20');
    var numberPosX = parseFloat(root.getAttribute('data-number-pos-x') || '50');
    var numberPosY = parseFloat(root.getAttribute('data-number-pos-y') || '70');
    var formId = root.getAttribute('data-form-id');
    var currentColorHex = root.getAttribute('data-first-color') || '#000000';
    var currentSchoolColorHex = root.getAttribute('data-first-color') || '#000000';

    var referenceImg = localImage;
    var referenceAncestor = stage;
    var resizeObserver = null;
    var addToCartButton = null;
    var addToCartOriginallyDisabled = false;

    namePreview.style.position = 'absolute';
    schoolNamePreview.style.position = 'absolute';
    digitsContainer.style.position = 'absolute';

    function updateAddToCartState() {
      if (!addToCartButton || addToCartOriginallyDisabled) return;
      addToCartButton.disabled = editButton.hidden;
    }

    function recalculateOverlay() {
      if (!referenceImg) return;
      var metrics = getImageMetrics(referenceImg, referenceAncestor);
      if (!metrics) return;

      var nameX = metrics.imgOffsetLeft + (namePosX / 100) * metrics.renderedWidth - metrics.cropOffsetX;
      var nameY = metrics.imgOffsetTop + (namePosY / 100) * metrics.renderedHeight - metrics.cropOffsetY;
      namePreview.style.left = nameX + 'px';
      namePreview.style.top = nameY + 'px';
      namePreview.style.transform = 'translate(-50%, -50%)';
      namePreview.style.fontSize = (nameFontPct / 100 * metrics.renderedWidth) + 'px';

      var schoolNameX = metrics.imgOffsetLeft + (schoolNamePosX / 100) * metrics.renderedWidth - metrics.cropOffsetX;
      var schoolNameY = metrics.imgOffsetTop + (schoolNamePosY / 100) * metrics.renderedHeight - metrics.cropOffsetY;
      schoolNamePreview.style.left = schoolNameX + 'px';
      schoolNamePreview.style.top = schoolNameY + 'px';
      schoolNamePreview.style.transform = 'translate(-50%, -50%)';
      schoolNamePreview.style.fontSize = (schoolNameFontPct / 100 * metrics.renderedWidth) + 'px';

      var numberX = metrics.imgOffsetLeft + (numberPosX / 100) * metrics.renderedWidth - metrics.cropOffsetX;
      var numberY = metrics.imgOffsetTop + (numberPosY / 100) * metrics.renderedHeight - metrics.cropOffsetY;
      digitsContainer.style.left = numberX + 'px';
      digitsContainer.style.top = numberY + 'px';
      digitsContainer.style.transform = 'translate(-50%, -50%)';
      digitsContainer.style.gap = (digitGapPct / 100 * metrics.renderedWidth) + 'px';

      var digitEls = digitsContainer.querySelectorAll('.product-customizer__digit');
      for (var i = 0; i < digitEls.length; i++) {
        digitEls[i].style.width = (digitSizePct / 100 * metrics.renderedWidth) + 'px';
      }
    }

    function observe(img, ancestor) {
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
      referenceImg = img;
      referenceAncestor = ancestor;
      if (img && window.ResizeObserver) {
        resizeObserver = new ResizeObserver(recalculateOverlay);
        resizeObserver.observe(img);
        resizeObserver.observe(ancestor);
      }
      if (img && img.complete) {
        recalculateOverlay();
      } else if (img) {
        img.addEventListener('load', recalculateOverlay, { once: true });
      }
    }

    function renderName() {
      // Force uppercase on the actual value (not just a CSS text-transform)
      // so the line item property submitted with the order — what print
      // production actually reads — always matches what the preview shows.
      // Allows letters, spaces, hyphens, and apostrophes (e.g. "O'BRIEN").
      var filtered = nameInput.value.replace(/[^A-Za-z '\-]/g, '').slice(0, nameMaxLength).toUpperCase();
      if (filtered !== nameInput.value) {
        nameInput.value = filtered;
      }
      namePreview.textContent = filtered;
    }

    function renderSchoolName() {
      // Same filtering/behavior as renderName(), just a separate field,
      // preview element, and max length.
      var filtered = schoolNameInput.value.replace(/[^A-Za-z '\-]/g, '').slice(0, schoolNameMaxLength).toUpperCase();
      if (filtered !== schoolNameInput.value) {
        schoolNameInput.value = filtered;
      }
      schoolNamePreview.textContent = filtered;
    }

    // Renders the digit graphics from the RAW, literal characters the
    // customer typed (already sanitized to 0-2 digit characters by the
    // input handler below) — no parsing to a number and back, so "0", "01",
    // "02" all render exactly as entered instead of being reformatted.
    function renderDigits() {
      var value = numberInput.value;
      if (!value) {
        digitsContainer.innerHTML = '';
        recalculateOverlay();
        return;
      }
      var digits = value.split('');
      var urls = digits.map(function (digitChar) {
        return digitUrls[parseInt(digitChar, 10)];
      });

      Promise.all(urls.map(function (url) {
        return url ? fetchSvgText(url) : Promise.resolve(null);
      })).then(function (svgTexts) {
        // Guard against out-of-order async resolution overwriting a newer value.
        if (numberInput.value !== value) return;
        digitsContainer.innerHTML = '';
        svgTexts.forEach(function (svgText) {
          if (!svgText) return;
          var wrapper = document.createElement('span');
          wrapper.className = 'product-customizer__digit';
          wrapper.innerHTML = svgText;
          var svgEl = wrapper.querySelector('svg');
          if (svgEl) {
            applyColorToSvg(svgEl, currentColorHex);
          }
          digitsContainer.appendChild(wrapper);
        });
        recalculateOverlay();
      });
    }

    function applyColor(colorHex) {
      currentColorHex = colorHex;
      namePreview.style.color = colorHex;
      digitsContainer.querySelectorAll('svg').forEach(function (svgEl) {
        applyColorToSvg(svgEl, colorHex);
      });
    }

    function applySchoolColor(colorHex) {
      currentSchoolColorHex = colorHex;
      schoolNamePreview.style.color = colorHex;
    }

    // Renders a fixed "00" using the same digit graphics as renderDigits(),
    // for the placeholder shown before any real customization is saved.
    function renderPlaceholderDigits() {
      var digits = PLACEHOLDER_NUMBER.split('');
      var urls = digits.map(function (digitChar) {
        return digitUrls[parseInt(digitChar, 10)];
      });

      Promise.all(urls.map(function (url) {
        return url ? fetchSvgText(url) : Promise.resolve(null);
      })).then(function (svgTexts) {
        digitsContainer.innerHTML = '';
        svgTexts.forEach(function (svgText) {
          if (!svgText) return;
          var wrapper = document.createElement('span');
          wrapper.className = 'product-customizer__digit';
          wrapper.innerHTML = svgText;
          var svgEl = wrapper.querySelector('svg');
          if (svgEl) {
            applyColorToSvg(svgEl, currentColorHex);
          }
          digitsContainer.appendChild(wrapper);
        });
        recalculateOverlay();
      });
    }

    // Shows "SCHOOL" / "YOUR NAME" / "00" directly on the real product
    // image, at the same positions/colors a real customization would use,
    // so the page never looks blank before anyone has customized anything.
    // Replaced the moment a real customization is saved; brought back if
    // the popup is closed without saving, or on a variant switch.
    function showPlaceholder() {
      schoolNamePreview.textContent = PLACEHOLDER_SCHOOL;
      namePreview.textContent = PLACEHOLDER_NAME;
      renderPlaceholderDigits();
      reattachOverlayToActiveMedia();
    }

    // Moves the overlay elements into whichever media is currently active,
    // WITHOUT touching their content — used both right after showPlaceholder()
    // sets placeholder text, and by the gallery observer below when a variant
    // switch's async image swap orphans them without changing any text.
    function reattachOverlayToActiveMedia() {
      var activeMedia = findActiveMedia();
      if (!activeMedia) return;
      var activeImg = activeMedia.querySelector('img');
      activeMedia.appendChild(namePreview);
      activeMedia.appendChild(schoolNamePreview);
      activeMedia.appendChild(digitsContainer);
      observe(activeImg || activeMedia, activeMedia);
    }

    function syncLocalImageToActiveMedia() {
      var activeMedia = findActiveMedia();
      var img = activeMedia ? activeMedia.querySelector('img') : null;
      if (!img || !localImage) return;
      localImage.src = img.currentSrc || img.src;
      var rect = img.getBoundingClientRect();
      if (rect.width && rect.height) {
        localImage.style.aspectRatio = rect.width + ' / ' + rect.height;
        localImage.style.objectFit = 'cover';
      }
    }

    function openDialog() {
      syncLocalImageToActiveMedia();
      dialog.showModal();
      document.body.style.overflow = 'hidden';
      recalculateOverlay();
    }

    function closeDialog() {
      if (dialog.open) {
        dialog.close();
      }
      document.body.style.overflow = '';
    }

    function resetCustomization() {
      nameInput.value = '';
      schoolNameInput.value = '';
      numberInput.value = '';
      colorButtons.forEach(function (btn, index) {
        btn.classList.toggle('is-selected', index === 0);
      });
      if (colorButtons.length > 0) {
        applyColor(colorButtons[0].getAttribute('data-customizer-color'));
        colorHiddenInput.value = colorButtons[0].getAttribute('data-customizer-color-label');
      }
      schoolColorButtons.forEach(function (btn, index) {
        btn.classList.toggle('is-selected', index === 0);
      });
      if (schoolColorButtons.length > 0) {
        applySchoolColor(schoolColorButtons[0].getAttribute('data-customizer-school-color'));
        schoolColorHiddenInput.value = schoolColorButtons[0].getAttribute('data-customizer-school-color-label');
      }
      closeDialog();
      trigger.hidden = false;
      if (note) note.hidden = false;
      editButton.hidden = true;
      updateAddToCartState();
      showPlaceholder();
    }

    trigger.addEventListener('click', function () {
      // Clear the placeholder before entering the editing popup, so the
      // live preview starts blank instead of showing "SCHOOL"/"YOUR
      // NAME"/"00" while typing — those are only meant for the real page
      // before anyone has started customizing.
      namePreview.textContent = '';
      schoolNamePreview.textContent = '';
      digitsContainer.innerHTML = '';
      stage.appendChild(namePreview);
      stage.appendChild(schoolNamePreview);
      stage.appendChild(digitsContainer);
      observe(localImage, stage);
      openDialog();
    });
    editButton.addEventListener('click', function () {
      stage.appendChild(namePreview);
      stage.appendChild(schoolNamePreview);
      stage.appendChild(digitsContainer);
      observe(localImage, stage);
      openDialog();
    });

    if (closeButton) {
      closeButton.addEventListener('click', closeDialog);
    }

    dialog.addEventListener('close', function () {
      document.body.style.overflow = '';
      // If the popup closes and nothing has ever been saved (trigger
      // still showing, not "Edit customization"), the preview elements
      // are sitting empty inside the now-hidden dialog — bring back the
      // placeholder on the real image instead of leaving it blank.
      // trigger.hidden is true exactly when a customization HAS been
      // saved (Save hides it in favor of "Edit customization") — so
      // skip restoring the placeholder in that case, not the reverse.
      if (trigger.hidden) return;
      showPlaceholder();
    });

    if (saveButton) {
      saveButton.addEventListener('click', function () {
        if (!nameInput.reportValidity() || !schoolNameInput.reportValidity() || !numberInput.reportValidity()) {
          return;
        }
        var activeMedia = findActiveMedia();
        if (activeMedia) {
          var activeImg = activeMedia.querySelector('img');
          activeMedia.appendChild(namePreview);
          activeMedia.appendChild(schoolNamePreview);
          activeMedia.appendChild(digitsContainer);
          observe(activeImg || activeMedia, activeMedia);
        }
        // Set these before closeDialog() — closing fires the dialog's
        // "close" listener above synchronously, which checks
        // trigger.hidden to decide whether to restore the placeholder.
        // It must already reflect "saved" by that point, or the
        // placeholder would incorrectly reappear over what was just saved.
        trigger.hidden = true;
        if (note) note.hidden = true;
        editButton.hidden = false;
        updateAddToCartState();
        closeDialog();
      });
    }

    nameInput.addEventListener('input', renderName);
    schoolNameInput.addEventListener('input', renderSchoolName);
    numberInput.addEventListener('input', function () {
      var sanitized = sanitizeNumberValue(numberInput.value);
      if (sanitized !== numberInput.value) {
        numberInput.value = sanitized;
      }
      renderDigits();
    });

    [nameInput, schoolNameInput, numberInput].forEach(function (input) {
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
        }
      });
    });

    colorButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        colorButtons.forEach(function (btn) { btn.classList.remove('is-selected'); });
        button.classList.add('is-selected');
        applyColor(button.getAttribute('data-customizer-color'));
        colorHiddenInput.value = button.getAttribute('data-customizer-color-label');
      });
    });

    schoolColorButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        schoolColorButtons.forEach(function (btn) { btn.classList.remove('is-selected'); });
        button.classList.add('is-selected');
        applySchoolColor(button.getAttribute('data-customizer-school-color'));
        schoolColorHiddenInput.value = button.getAttribute('data-customizer-school-color-label');
      });
    });

    document.addEventListener('product:select', function (event) {
      var settle = event && event.promise ? event.promise : Promise.resolve();
      settle.then(resetCustomization);
    });

    // A variant switch's actual image swap happens asynchronously and
    // isn't fully covered by product:select's own promise — resetCustomization()
    // above can run and correctly reattach the overlay, only for Horizon's
    // later gallery update to silently discard it a moment after. This
    // observer catches that later swap and reattaches whatever's already
    // set (placeholder or, potentially, saved content) — it never changes
    // any text itself, it only notices when the overlay elements have been
    // orphaned from the currently-visible slide and moves them back.
    //
    // Observing <media-gallery> itself isn't enough — confirmed live that
    // Horizon replaces that whole element wholesale on a variant switch
    // (a fresh element, not the same node with updated children), which
    // would silently disconnect an observer attached directly to it.
    // document.body is the narrowest ancestor guaranteed to never itself
    // be replaced.
    var galleryObserver = new MutationObserver(function () {
      if (dialog.open) return; // mid-edit: elements belong in the popup, not here
      var activeMedia = findActiveMedia();
      if (!activeMedia || activeMedia.contains(namePreview)) return;
      reattachOverlayToActiveMedia();
    });
    galleryObserver.observe(document.body, { childList: true, subtree: true });

    window.addEventListener('resize', recalculateOverlay);

    if (formId) {
      var form = document.getElementById(formId);
      if (form) {
        form.addEventListener('submit', function (event) {
          if (!nameInput.value || !schoolNameInput.value || !numberInput.value) {
            event.preventDefault();
            openDialog();
            nameInput.focus();
          }
        });

        addToCartButton = form.querySelector('button[name="add"]');
        if (addToCartButton) {
          addToCartOriginallyDisabled = addToCartButton.disabled;
        }
      }
    }

    showPlaceholder();
    updateAddToCartState();
  }

  document.querySelectorAll('[data-product-customizer]').forEach(initCustomizer);
})();
